export default __webpack_public_path__ + "static/media/Himalayas_Map.119cde3c.png";